import React from "react";
import { Component } from "react";
import { SelectField } from "../../../common/custom-form/select-filter.component";
import { DetailsDataTable } from "./details-table/details-table.component";
import { Button } from "react-bootstrap";
export class AddPlanDetails extends Component {
    constructor(props) {
        super(props);
        this.state={
            filterSelected:""
        }
    }
    ShowTable() {        
        this.props.showDetails(true)
    }
    render() {
        return(
            <div className="add-plan-container">
                 <SelectField label="PLAN NAME"  options={this.props.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>  
                 {this.state.filterSelected &&
                    <>
                     <DetailsDataTable datatable={this.props.datatable} haveEditRemoveBtn={this.props.haveEditRemoveBtn} />
                    <div className="add-button-container ">
                        <Button>Cancel</Button>
                        <Button onClick={this.ShowTable.bind(this)}>Add</Button>
                    </div>
                    </> 
                 }
            </div>
        )
    }
}